var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-data-table',{ref:"RkmDataTable",attrs:{"fields":_vm.fields,"repository":_vm.repositories.fechamentoFaaMassa,"sort-by":"faaId","search-by":"unidadeNomeFantasia"}})
}
var staticRenderFns = []

export { render, staticRenderFns }